<template>
  <section class="gs-aff-section">
    <div class="gs-aff-section__head">
      <div>
        <strong>Recurring commission schedule</strong>
        <p>Each row covers the next group of payments. Leave the last row blank to keep paying on all remaining payments.</p>
      </div>
    </div>
    <div class="gs-aff-schedule">
      <div
        v-for="(commissionDetail, commissionDetailIndex) in commissionTier.rebill_commissions"
        :key="commissionDetailIndex"
        class="gs-aff-schedule__row"
      >
        <div class="gs-aff-schedule__range">
          <small>{{ rangeLabel(commissionDetailIndex) }}</small>
          <strong>{{ rangeDescription(commissionDetailIndex) }}</strong>
        </div>
        <label class="gs-aff-field">
          <span class="gs-aff-field__label">Payments</span>
          <input
            v-model="commissionDetail.no_of_payments"
            class="gs-aff-input"
            type="number"
            min="1"
            :placeholder="commissionDetailIndex === commissionTier.rebill_commissions.length - 1 ? 'All remaining' : 'e.g. 11'"
          />
        </label>
        <label class="gs-aff-field">
          <span class="gs-aff-field__label">Tier 1 payout</span>
          <span class="gs-aff-input-pair">
            <input v-model="commissionDetail.commission" class="gs-aff-input" type="number" min="0" aria-label="Tier 1 payout" />
            <select v-model="commissionDetail.commission_type" class="gs-aff-select" aria-label="Tier 1 payout type">
              <option v-for="option in commissionTypeOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
            </select>
          </span>
        </label>
        <label class="gs-aff-field">
          <span class="gs-aff-field__label">Tier 2 payout</span>
          <span class="gs-aff-input-pair">
            <input v-model="commissionDetail.jv_broker_commission" class="gs-aff-input" type="number" min="0" aria-label="Tier 2 payout" />
            <select v-model="commissionDetail.jv_broker_commission_type" class="gs-aff-select" aria-label="Tier 2 payout type">
              <option v-for="option in commissionTypeOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
            </select>
          </span>
        </label>
        <gs-button
          v-if="commissionTier.rebill_commissions.length > 1"
          type="button"
          variant="ghost"
          size="sm"
          class="is-destructive"
          aria-label="Remove this payment group"
          title="Remove this payment group"
          @click="commissionTier.rebill_commissions.splice(commissionDetailIndex, 1)"
        >
          <gs-icon name="trash" size="16"></gs-icon>
        </gs-button>
      </div>
    </div>
    <div class="gs-aff-actions">
      <gs-button type="button" variant="outline" size="sm" @click="commissionTier.rebill_commissions.push(newRebill(50))">
        <gs-icon name="plus" size="14"></gs-icon>
        Add payment group
      </gs-button>
      <gs-button type="button" variant="ghost" size="sm" @click="commissionTier.rebill_commissions.push(newRebill(0))">
        Stop commissions after this schedule
      </gs-button>
    </div>
  </section>
</template>

<script>
import { recurringRangeLabel, recurringRangeDescription, newRebillCommission } from './commissionFormat';

export default {
  props: {
    commissionTier: {
      type: Object,
      required: true,
    },
    commissionTypeOptions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    rangeLabel(index) {
      return recurringRangeLabel(this.commissionTier.rebill_commissions, index);
    },
    rangeDescription(index) {
      return recurringRangeDescription(this.commissionTier.rebill_commissions, index);
    },
    newRebill(commission) {
      return newRebillCommission(commission);
    },
  },
};
</script>
